import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid, Checkbox } from '@material-ui/core'
import PropTypes from 'prop-types'




export default class ProgramLucru extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            programCompanie: [],
            programSelectat: -1
        }
    }

    componentDidMount() {

    }

    absent = (zi) => {

    }



    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    fullWidth={true}
                    disableEnforceFocus
                    maxWidth='md'
                    style={{
                        zIndex: 5100,
                    }}
                    open={this.props.open}
                    onClose={this.props.dialogClose}>
                    <DialogActions >
                        <Fab style={{
                            backgroundColor: 'transparent',
                            boxShadow: 'none'
                        }} onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i style={{ color: 'black', fontSize: 30 }} className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>


                    <DialogContent>
                        <Grid container className="container pm-dialog-textfield-container" >
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>
                                    <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                                        <h4 className='pm-title' style={{ textAlign: 'left', fontSize: 24, fontWeight: 500, color: 'black', paddingLeft: 40 }}>
                                            <span style={{ display: 'inline-flex' }}> {this.props.limba.organigrama.programLucru}</span>

                                        </h4>

                                    </Grid>

                                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                        <div style={{ position: 'relative', textAlign: 'left' }}>
                                            <select
                                                id='program'
                                                style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                                className='add-project-input'
                                                type="text"
                                                margin="normal"
                                                name='program'
                                                // disabled={this.state.tip_bilantDisabled !== 1 ? true : false}
                                                value={this.props.programSelectat || '-1'}
                                                onChange={this.props.changeProgramAll}
                                            // placeholder={this.dictionary.pontaje.tip_bilantCautaLucrator}
                                            // onBlur={this.props.updateAngajatData}
                                            >


                                                <option value={-1}>Selectati Program</option>

                                                {this.props.programCompanie.map((s, idx) => {
                                                    return (
                                                        <option key={idx} value={s.id}>{s.nume_template}</option>
                                                    )
                                                })}


                                            </select>
                                            <label className='inputLabelPM' htmlFor='tipCost'>{this.props.limba.managementUtilizatori.selecteazaProgram}</label>
                                        </div>

                                    </Grid>
                                </Grid>

                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >

                                <div style={{ width: '90%' }}>
                                    <h3 style={{ marginBottom: 3 }} className="pm-title">
                                        <Checkbox style={{ color: '#000000', padding: 0 }}
                                            onChange={(ev) => { this.props.absent(ev, 'lu_start') }}
                                            checked={this.props.angajat.lu_start === '00:00' ? false : true} />
                                        {this.props.limba.zileleSapt.luni}</h3>

                                    {this.props.angajat.lu_start !== '00:00' &&
                                        <div className='pm-program-ore-container'>
                                            <TextField
                                                style={{ display: 'block' }}
                                                className=" loginTextField centerLabel"

                                                id="with-placeholder"
                                                type='time'
                                                label={this.props.limba.organigrama.inceputProg}
                                                margin="normal"
                                                value={this.props.angajat.lu_start || ''}
                                                onChange={this.props.changeProgram('lu_start')}
                                            />
                                            <TextField
                                                style={{ display: 'block' }}
                                                className=" loginTextField centerLabel"
                                                id="with-placeholder"
                                                type='time'
                                                label={this.props.limba.organigrama.sfarsitProg}
                                                margin="normal"
                                                value={this.props.angajat.lu_end || ''}
                                                onChange={this.props.changeProgram('lu_end')}
                                            />
                                        </div>
                                    }

                                </div>
                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >

                                <div style={{ width: '90%' }}>
                                    <h3 style={{ marginBottom: 3 }} className="pm-title">
                                        <Checkbox style={{ color: '#000000', padding: 0 }}
                                            onChange={(ev) => { this.props.absent(ev, 'ma_start') }}
                                            checked={this.props.angajat.ma_start === '00:00' ? false : true} />
                                        {this.props.limba.zileleSapt.marti}</h3>

                                    {this.props.angajat.ma_start !== '00:00' &&
                                        <div className='pm-program-ore-container'>
                                            <TextField
                                                style={{ display: 'block' }}
                                                className=" loginTextField centerLabel"
                                                id="with-placeholder"
                                                type='time'
                                                label={this.props.limba.organigrama.inceputProg}
                                                margin="normal"
                                                value={this.props.angajat.ma_start || ''}
                                                onChange={this.props.changeProgram('ma_start')}
                                            />
                                            <TextField
                                                style={{ display: 'block' }}
                                                className=" loginTextField centerLabel"
                                                id="with-placeholder"
                                                type='time'
                                                label={this.props.limba.organigrama.sfarsitProg}
                                                margin="normal"
                                                value={this.props.angajat.ma_end || ''}
                                                onChange={this.props.changeProgram('ma_end')}
                                            />
                                            {/* <TextField
                                            style={{ display: 'block' }}
                                            className=" loginTextField centerLabel"
                                            id="with-placeholder"
                                            type='time'
                                            label={this.props.limba.organigrama.sfarsitProg}
                                            margin="normal"
                                            value={this.props.angajat.ma_end || ''}
                                            onChange={() => { this.props.changeProgram('ma_end') }}
                                        /> */}

                                        </div>
                                    }
                                </div>
                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >


                                <div style={{ width: '90%' }}>
                                    <h3 style={{ marginBottom: 3 }} className="pm-title">    <Checkbox style={{ color: '#000000', padding: 0 }}
                                        onChange={(ev) => { this.props.absent(ev, 'mi_start') }}
                                        checked={this.props.angajat.mi_start === '00:00' ? false : true} />
                                        {this.props.limba.zileleSapt.miercuri}</h3>

                                    {this.props.angajat.mi_start !== '00:00' &&
                                        <div className='pm-program-ore-container'>
                                            <TextField
                                                style={{ display: 'block' }}
                                                className=" loginTextField centerLabel"
                                                id="with-placeholder"
                                                type='time'
                                                label={this.props.limba.organigrama.inceputProg}
                                                margin="normal"
                                                value={this.props.angajat.mi_start || ''}
                                                onChange={this.props.changeProgram('mi_start')}
                                            />
                                            <TextField
                                                style={{ display: 'block' }}
                                                className=" loginTextField centerLabel"
                                                id="with-placeholder"
                                                type='time'
                                                label={this.props.limba.organigrama.sfarsitProg}
                                                margin="normal"
                                                value={this.props.angajat.mi_end || ''}
                                                onChange={this.props.changeProgram('mi_end')}
                                            />
                                        </div>

                                    }
                                </div>

                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >

                                <div style={{ width: '90%' }}>
                                    <h3 style={{ marginBottom: 3 }} className="pm-title">
                                        <Checkbox style={{ color: '#000000', padding: 0 }}
                                            onChange={(ev) => { this.props.absent(ev, 'jo_start') }}
                                            checked={this.props.angajat.jo_start === '00:00' ? false : true} />
                                        {this.props.limba.zileleSapt.joi}</h3>

                                    {this.props.angajat.jo_start !== '00:00' &&
                                        <div className='pm-program-ore-container'>
                                            <TextField
                                                style={{ display: 'block' }}
                                                className=" loginTextField centerLabel"
                                                id="with-placeholder"
                                                type='time'
                                                label={this.props.limba.organigrama.inceputProg}
                                                margin="normal"
                                                value={this.props.angajat.jo_start || ''}
                                                onChange={this.props.changeProgram('jo_start')}
                                            />
                                            <TextField
                                                style={{ display: 'block' }}
                                                className=" loginTextField centerLabel"
                                                id="with-placeholder"
                                                type='time'
                                                label={this.props.limba.organigrama.sfarsitProg}
                                                margin="normal"
                                                value={this.props.angajat.jo_end || ''}
                                                onChange={this.props.changeProgram('jo_end')}
                                            />

                                        </div>
                                    }
                                </div>
                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <div style={{ width: '90%' }}>

                                    <h3 style={{ marginBottom: 3 }} className="pm-title">  <Checkbox style={{ color: '#000000', padding: 0 }}
                                        onChange={(ev) => { this.props.absent(ev, 'vi_start') }}
                                        checked={this.props.angajat.vi_start === '00:00' ? false : true} />{this.props.limba.zileleSapt.vineri}</h3>


                                    {this.props.angajat.vi_start !== '00:00' &&
                                        <div className='pm-program-ore-container'>
                                            <TextField
                                                style={{ display: 'block' }}
                                                className=" loginTextField centerLabel"
                                                id="with-placeholder"
                                                type='time'
                                                label={this.props.limba.organigrama.inceputProg}
                                                margin="normal"
                                                value={this.props.angajat.vi_start || ''}
                                                onChange={this.props.changeProgram('vi_start')}
                                            />
                                            <TextField
                                                style={{ display: 'block' }}
                                                className=" loginTextField centerLabel"
                                                id="with-placeholder"
                                                type='time'
                                                label={this.props.limba.organigrama.sfarsitProg}
                                                margin="normal"
                                                value={this.props.angajat.vi_end || ''}
                                                onChange={this.props.changeProgram('vi_end')}
                                            />

                                        </div>


                                    }
                                </div>

                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >

                                <div style={{ width: '90%' }}>
                                    <h3 style={{ marginBottom: 3 }} className="pm-title"><Checkbox style={{ color: '#000000', padding: 0 }}
                                        onChange={(ev) => { this.props.absent(ev, 'sa_start') }}
                                        checked={this.props.angajat.sa_start === '00:00' ? false : true} />{this.props.limba.zileleSapt.sambata}</h3>

                                    {this.props.angajat.sa_start !== '00:00' &&
                                        <div className='pm-program-ore-container'>
                                            <TextField
                                                style={{ display: 'block' }}
                                                className=" loginTextField centerLabel"
                                                id="with-placeholder"
                                                type='time'
                                                label={this.props.limba.organigrama.inceputProg}
                                                margin="normal"
                                                value={this.props.angajat.sa_start || ''}
                                                onChange={this.props.changeProgram('sa_start')}
                                            />
                                            <TextField
                                                style={{ display: 'block' }}
                                                className=" loginTextField centerLabel"
                                                id="with-placeholder"
                                                type='time'
                                                label={this.props.limba.organigrama.sfarsitProg}
                                                margin="normal"
                                                value={this.props.angajat.sa_end || ''}
                                                onChange={this.props.changeProgram('sa_end')}
                                            />
                                        </div>


                                    }
                                </div>

                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >

                                <div style={{ width: '90%' }}>
                                    <h3 style={{ marginBottom: 3 }} className="pm-title"> <Checkbox style={{ color: '#000000', padding: 0 }}
                                        onChange={(ev) => { this.props.absent(ev, 'du_start') }}
                                        checked={this.props.angajat.du_start === '00:00' ? false : true} />{this.props.limba.zileleSapt.duminica}</h3>


                                    {this.props.angajat.du_start !== '00:00' &&
                                        <div className='pm-program-ore-container'>
                                            <TextField
                                                style={{ display: 'block' }}
                                                className=" loginTextField centerLabel"
                                                id="with-placeholder"
                                                type='time'
                                                label={this.props.limba.organigrama.inceputProg}
                                                margin="normal"
                                                value={this.props.angajat.du_start || ''}
                                                onChange={this.props.changeProgram('du_start')}

                                            />
                                            <TextField
                                                style={{ display: 'block' }}
                                                className=" loginTextField centerLabel"
                                                id="with-placeholder"
                                                type='time'
                                                label={this.props.limba.organigrama.sfarsitProg}
                                                margin="normal"
                                                value={this.props.angajat.du_end || ''}
                                                onChange={this.props.changeProgram('du_end')}
                                            />

                                        </div>


                                    }
                                </div>

                            </Grid>

                        </Grid>

                    </DialogContent>


                    <DialogActions className="pm-dialog-bottom-buttons">
                        <Button
                            style={{ backgroundColor: 'rgb(24 165 58 )', textTransform: 'unset', paddingLeft: 40, paddingRight: 40 }}
                            variant="contained"
                            color="primary"
                            onClick={this.props.salveazaProgram}
                        >
                            {this.props.limba.comune.save}
                        </Button>




                    </DialogActions>


                </Dialog>
            </div>
        );
    }
}

// end class


ProgramLucru.propTypes = {
    open: PropTypes.bool,
    dialogClose: PropTypes.func,
    limba: PropTypes.object,
    absent: PropTypes.func,
    angajat: PropTypes.object,
    changeProgram: PropTypes.func,


}